<template>
  <div class="tableContents">
    <div class="container">
      <h1 class="section-title" data-aos="fade-up" data-aos-delay="100">
        {{$t('heading.headingContent')}}
      </h1>
      <div class="d-flex justify-content-between bg">
        <ul>
          <li v-show="$route.name != 'Home'"> 
            <router-link  :to="`/${$i18n.locale}`" v-on:click.native="closeTableContents"
              >{{$t('content.homepage')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/viceChairman-message`"
              v-on:click.native="closeTableContents"
              >{{$t('content.chairmanMsg')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/sustainabilityOfficer-message`"
              v-on:click.native="closeTableContents"
              >{{$t('content.csoMsg')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/introduction`"
              v-on:click.native="closeTableContents"
              >{{$t('content.Introduction')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/aspects-of-gender-disparity`"
              v-on:click.native="closeTableContents"
              >{{$t('content.genderDisparity')}}
            </router-link>
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/gender-digital-divide`"
              v-on:click.native="closeTableContents"
              >{{$t('content.digitalDivide')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/literacy-and-stem-education`"
              v-on:click.native="closeTableContents"
              >{{$t('content.stemeducation')}}</router-link
            >
          </li>
        </ul>
        <ul>
          <li>
            <router-link
              :to="`/${$i18n.locale}/employment-equality`"
              v-on:click.native="closeTableContents"
              >{{$t('content.employmentEquality')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/gender-biasis-in-stem`"
              v-on:click.native="closeTableContents"
              >{{$t('content.genderBiases')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/innovation-in-stem`"
              v-on:click.native="closeTableContents"
              >{{$t('content.innovation')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/Developing-stem-skills-to-achieve-financial-inclusion`"
              v-on:click.native="closeTableContents"
              >{{$t('content.financialInclusion')}}</router-link
            >
          </li>
          <li>
            <router-link
              :to="`/${$i18n.locale}/covid-19-and-women-in-technology`"
              v-on:click.native="closeTableContents"
              >{{$t('content.womenTechnology')}}</router-link
            >
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/conclusion`" v-on:click.native="closeTableContents"
              >{{$t('content.Conclusion')}}</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      homePage: false
    };
  },
  methods: {
    closeTableContents() {
      document.body.classList.remove("isVisible");
    }
  }
};
</script>
<style lang="scss" scoped>
.tableContents {
  overflow: hidden;
  background: url(../../assets/images/banner/table-of-contents-banner.png)
    center center no-repeat;
  background-attachment: fixed;
  background-size: cover;
  padding: 40px 0;
  padding-bottom: 100px;
  height: 100vh;
 @media screen and (max-width: 1199px) {
        overflow-y: scroll;
  }
  .bg {
    background: rgba(0, 0, 0, 0.4);
    padding: 35px 20px;
    padding-bottom: 20px;
    margin-top:20px;
    @media screen and (max-width:991px){
      margin-top:20px;
    }
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
  }
  .graphics {
    top: 90px;
    right: 20px;
    left: auto;
    max-width: 150px;
    @media screen and (max-width: 1400px) {
      top: 0;
      max-width: 100px;
    }
  }
  h1 {
    color: #52b9e9;
    text-shadow: none;
    padding-top: 60px;
    margin-bottom:0;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    max-width: 48%;
    flex: 0 0 48%;
    &:first-child {
      margin-right: 30px;
    }
    li {
      display: flex;
      color: #fff;
      font-size: 15px;
      font-weight: 900;
      margin-bottom: 35px;
      &:first-child {
        display: block;
      }

      span {
        color: #50b848;
        margin-right: 6px;
        font-weight: 700;
      }
      p {
        color: #52b9e9;
        font-size: 13px;
        line-height: 1;
        margin: 0;
        margin-left: 25px;
        margin-top: 5px;
        font-weight: 700;
      }
      a {
        color: #fff;
        font-size: 22px;
        font-weight: 900;
        transition: 0.5s ease all;
        display: inline-block;
        position: relative;
        text-transform: uppercase;
        text-decoration: none !important;
        line-height: 1.2;
        border: 0;
        &:after {
          content: "";
          transition: all 0.3s ease;
          position: absolute;
          width: 60px;
          height: 6px;
          background: #52b9e9 !important;
          left: 0;
          bottom: -10px;
        }
        &:hover {
          &:after {
            width: 100%;
          }
        }
        &.router-link-exact-active {
          &:after {
            width: 100%;
            background:#f5eb00 !important;
          }
        }
      }
    }
    @media screen and (max-width: 1400px) {
      li {
        font-size: 19px;
        a {
          font-size: 19px;
          line-height: 1.3
        }
      }
    }
    @media screen and (max-width: 767px) {
      max-width: 100%;
      flex: 0 0 100%;
      &:first-child {
        margin-right: 0;
      }
      li {
        font-size: 17px;
        margin-bottom: 25px;
        a {
          font-size: 17px;
        }
      }
    }
    @media screen and (max-width: 575px) {
      li {
        a {
          font-size: 15px;
          line-height: 1.3;
        }
      }
    }
  }
  @media screen and (max-width: 1024px) {
    background: url(../../assets/images/banner/table-of-contents-banner-responsive.png)
      center center no-repeat;
  }
}

//ar style


.ar{
  .tableContents {
    background-image: url(../../assets/images/banner/table-of-contents-banner-ar.png);
    .graphics {
      
      left: 20px;
      right: auto;
       
    }
    
    ul {
      
      &:first-child {
        margin-left: 30px;
        margin-right: 0px;
      }
      li {
        

        span {
          margin-left: 6px;
          margin-right: 0px;
        }
        p {
          
          margin-left: 0;
          margin-right: 25px;
          
        }
        a {
          
          &:after {
            right: 0;
            left: auto;
          }
          
        }
      }
     
      @media screen and (max-width: 767px) {
        
        &:first-child {
          margin-left: 0;
        }
        
      }
      
    }
    @media screen and (max-width: 1024px) {
      background-image: url(../../assets/images/banner/table-of-contents-banner-ar-responsive.png);
    }
  }
}

/* iPhone 11 Pro Max */
/* 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)and (orientation : landscape){
.tableContents{
     ul{
        li{
          margin-bottom: 25px;
            a{
                font-size: 17px;
                line-height: 1.3
            }
        }
     }
}
    
 }
</style>
